agneta.directive('EcTopupDetails', function(Role_Account_Manager, $mdDialog, data) {

  var vm = this;
  vm.data = data.topup;

  function load() {
    vm.loading = true;
    Role_Account_Manager.topupGet({
      id: data.topup.id
    })
      .$promise
      .then(function(result) {
        vm.data = result;
      })
      .finally(function() {
        vm.loading = false;
      });
  }

  load();

  vm.remove = function() {

    vm.loading = true;

    Role_Account_Manager.topupRemove({
      id: data.id
    })
      .$promise
      .finally(function() {
        load();
      });

  };
  vm.recover = function() {

    vm.loading = true;

    Role_Account_Manager.topupRecover({
      id: data.id
    })
      .$promise
      .finally(function() {
        load();
      });

  };

  vm.invoice = function(){
    $mdDialog.open({
      partial: 'payment-invoice',
      data: {
        id: vm.data.invoiceId,
        customerId: data.account.role.customer.id
      }
    });
  };

});
